/**
 * Generates a short random ID.
 */
export function randomId(): string {
  return Math.random().toString(36).substring(2, 9);
}

/**
 * Linear interpolation between a and b.
 */
export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/**
 * Clamps a value between a minimum and maximum.
 */
export function clamp(val: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, val));
}

/**
 * Formats a number with commas (e.g. 1000 -> 1,000).
 */
export function formatNumber(n: number): string {
  return n.toLocaleString('en-US');
}

/**
 * Promise-based delay.
 */
export function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Picks a random element from an array.
 */
export function pickRandom<T>(arr: T[]): T | undefined {
  if (arr.length === 0) return undefined;
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
}
